import Swiper from 'swiper';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

const swup = new Swup({
    plugins: [new SwupPreloadPlugin()]
});

const colorScheme = document.querySelector('.color-scheme');
colorScheme.addEventListener('click', function () {
    if (document.body.classList.contains('inverted-color')) {
        document.body.classList.remove('inverted-color');
        localStorage.removeItem("bfsl-color-scheme");
    } else {
        document.body.classList.add('inverted-color');
        localStorage.setItem("bfsl-color-scheme", "inverted");
    }
});

if (localStorage.getItem("bfsl-color-scheme")) {
    document.body.classList.add('inverted-color');
}

const scrollToTop = document.querySelector('.scroll-to-top');
if (scrollToTop) {
    scrollToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        setTimeout(() => {
            window.location.hash = '';
        }, 1000)
    });
}

const about = document.getElementById('about');
if (about) {
    const aboutLink = document.querySelector('a[href*="#about"]');
    aboutLink.addEventListener('click', (e) => {
        e.preventDefault();
        about.scrollIntoView({
            behavior: "smooth"
        });
    });
}

function glyphsMobile() {
    if (window.innerWidth < 750 && !document.querySelector('.mobile-slider .swiper-container')) {
        const glyphsTable = document.querySelectorAll('.glyphs-table .table');
        for (let i = 0; i < glyphsTable.length; i++) {
            const glyphs = glyphsTable[i].querySelectorAll('.glyph span');
            const glyphSliderWrap = glyphsTable[i].parentElement.querySelector('.mobile-slider');
            const glyphSliderCont = document.createElement('div');
            glyphSliderCont.className = "swiper-container";
            glyphSliderWrap.appendChild(glyphSliderCont);

            const swiperWrap = document.createElement('div');
            swiperWrap.className = "swiper-wrapper";
            glyphSliderCont.appendChild(swiperWrap);

            glyphSliderWrap.classList.add('active');
            for (let i = 0; i < glyphs.length; i++) {
                if (glyphs[i].innerText) {
                    let glyphSlide = document.createElement('div');
                    glyphSlide.innerHTML = glyphs[i].parentElement.innerHTML;
                    glyphSlide.className = "swiper-slide live-font";
                    swiperWrap.appendChild(glyphSlide);
                }
            }
            const swiperPagination = document.createElement('div');
            swiperPagination.className = "swiper-pagination";
            glyphSliderCont.appendChild(swiperPagination);

            const swiperPrev = document.createElement('div');
            swiperPrev.className = "swiper-button-prev";
            glyphSliderCont.appendChild(swiperPrev);

            const swiperNext = document.createElement('div');
            swiperNext.className = "swiper-button-next";
            glyphSliderCont.appendChild(swiperNext);

            var glyphSwiper = new Swiper(glyphSliderCont, {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        }
        //mobileSlider = true;
    }
}


const init = () => {
    /*
    *
    * Custom quantity input
    * Element requires following HTML structure
    * <div class="number-input"><input type="number"/></div>
    * 
    *
    */

    function numberInput(element, options) {
        const spinner = element;

        const defaultOptions = {
            min: 1,
            max: 250,
            step: 1,
            value: 1
        };

        options = Object.assign({}, defaultOptions, options);

        const obj = {

            input: spinner.querySelector('input[type="number"]'),
            init() {
                this.setup();
                this.events();
                return this;
            },
            setup() {

                this.input.value = options.value;
                this.max = options.max;
                this.min = options.min;
                this.step = options.step;

                const qNav = document.createElement('div');
                const qUp = document.createElement('div');
                const qDown = document.createElement('div');

                qNav.setAttribute('class', 'number-input-nav');
                qUp.setAttribute('class', 'number-input-button number-input-button--up');
                qDown.setAttribute('class', 'number-input-button number-input-button--down');

                qUp.innerHTML = '+';
                qDown.innerHTML = '-';
                qNav.appendChild(qUp);
                qNav.appendChild(qDown);
                spinner.appendChild(qNav);

                this.btnUp = spinner.querySelector('.number-input-button--up');
                this.btnDown = spinner.querySelector('.number-input-button--down');
            },
            trigger() {
                //const event = document.createEvent('HTMLEvents');
                //event.initEvent('input', true, false);
                const event = new Event("input", { "bubbles": true, "cancelable": false });
                return event;
            },
            updateUp(that) {
                const oldValue = parseFloat(that.input.value);
                let newVal;
                if (oldValue >= that.max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + that.step;
                }
                that.input.value = Math.round(newVal * 100) / 100;
                that.input.dispatchEvent(that.trigger());
            },
            updateDown(that) {
                const oldValue = parseFloat(that.input.value);
                let newVal;
                if (oldValue <= that.min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - that.step;
                }
                that.input.value = Math.round(newVal * 100) / 100;
                that.input.dispatchEvent(that.trigger());
            },
            events() {
                this.btnUp.addEventListener('click', () => {
                    // const oldValue = parseFloat(this.input.value);
                    // let newVal;
                    // if (oldValue >= this.max) {
                    //     newVal = oldValue;
                    // } else {
                    //     newVal = oldValue + this.step;
                    // }
                    // this.input.value = Math.round(newVal * 100) / 100;
                    // this.input.dispatchEvent(this.trigger());
                    this.updateUp(this);
                });
                this.btnDown.addEventListener('click', () => {
                    // const oldValue = parseFloat(this.input.value);
                    // let newVal;
                    // if (oldValue <= this.min) {
                    //     newVal = oldValue;
                    // } else {
                    //     newVal = oldValue - this.step;
                    // }
                    // this.input.value = Math.round(newVal * 100) / 100;
                    // this.input.dispatchEvent(this.trigger());
                    this.updateDown(this);
                });
                this.input.addEventListener('change', () => {
                    if (parseInt(this.input.value, 16) < this.min) {
                        this.input.value = this.min;
                    }
                    if (parseInt(this.input.value, 16) > this.max) {
                        this.input.value = this.max;
                    }
                });
                // mouse down //
                let t, tt;
                this.btnUp.addEventListener('mousedown', () => {
                    const that = this;
                    t = setTimeout(function () {
                        tt = setInterval(function () {
                            // const oldValue = parseFloat(that.input.value);
                            // let newVal;
                            // if (oldValue >= that.max) {
                            //     newVal = oldValue;
                            // } else {
                            //     newVal = oldValue + that.step;
                            // }
                            // that.input.value = Math.round(newVal * 100) / 100;
                            // that.input.dispatchEvent(that.trigger());
                            that.updateUp(that);
                        }, 10);
                    }, 500);
                });
                this.btnUp.addEventListener('mouseup', () => {
                    clearTimeout(t);
                    clearTimeout(tt);
                });

                this.btnDown.addEventListener('mousedown', () => {
                    const that = this;
                    t = setTimeout(function () {
                        tt = setInterval(function () {
                            // const oldValue = parseFloat(that.input.value);
                            // let newVal;
                            // if (oldValue <= that.min) {
                            //     newVal = oldValue;
                            // } else {
                            //     newVal = oldValue - that.step;
                            // }
                            // that.input.value = Math.round(newVal * 100) / 100;
                            // that.input.dispatchEvent(that.trigger());
                            that.updateDown(that);
                        }, 10);
                    }, 500);
                });
                this.btnDown.addEventListener('mouseup', () => {
                    clearTimeout(t);
                    clearTimeout(tt);
                });
            }
        }
        return obj.init();
    }



    /**
     * @see https://stackoverflow.com/questions/49796934/add-a-text-suffix-to-input-type-number/49797347
     */
    function updateSuffix(inputEl) {
        const suffixElement = inputEl.parentElement.querySelector('.suffix');
        const width = getTextWidth(inputEl.value, 'inherit');
        suffixElement.style.left = width + 2 + 'px';
    }


    /**
     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
     * 
     * @param {String} text The text to be rendered.
     * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
     * 
     * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
     * https://stackoverflow.com/questions/49796934/add-a-text-suffix-to-input-type-number/49797347
     */
    function getTextWidth(text, font) {
        // re-use canvas object for better performance
        var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        var context = canvas.getContext("2d");
        context.font = font;
        var metrics = context.measureText(text);
        return metrics.width;
    }


    const typeTester = document.querySelectorAll('.type-tester');

    if (typeTester) {
        for (let i = 0; i < typeTester.length; i++) {
            // const sampleText = typeTester[i].querySelectorAll(".sample-text");

            // let originalWords = [];
            // for(let i = 0; i < sampleText.length; i++){
            //     originalWords.push(sampleText[i].innerText);
            // }
            const sampleText = typeTester[i].querySelector(".sample-text");
            let originalWords = sampleText.innerText;

            const typeSizeInput = typeTester[i].querySelector('.font-size');

            let fontSize = Math.round(parseFloat((window.getComputedStyle(sampleText, null).getPropertyValue('font-size'))));
            typeSizeInput.value = fontSize;
            window.addEventListener('resize', function () {
                fontSize = Math.round(parseFloat((window.getComputedStyle(sampleText, null).getPropertyValue('font-size'))));
                typeSizeInput.value = fontSize;
            });

            const numberInputs = typeTester[i].querySelectorAll(".custom-number-input");
            if (numberInputs.length > 0) {
                numberInputs.forEach((el) => {
                    numberInput(el, {
                        min: parseFloat(el.querySelector('input').min),
                        max: parseFloat(el.querySelector('input').max),
                        step: parseFloat(el.querySelector('input').step),
                        value: parseFloat(el.querySelector('input').value)
                    });
                });
            }

            // // range inputs //
            // const rangeTypeSize = typeTester[i].querySelector('.font-size[type="range"]');
            // const rangeLetterSpacing = typeTester[i].querySelector('.letter-spacing[type="range"]');
            // const rangeLineHeight = typeTester[i].querySelector('.line-height[type="range"]');

            // if(rangeTypeSize){
            //     rangeTypeSize.addEventListener("input", function(){
            //         let newFontSize = window.innerWidth * (this.value/100) + 'vw';
            //         sampleText.style.fontSize = newFontSize;        
            //     });
            // }
            // if(rangeLetterSpacing){    
            //     rangeLetterSpacing.addEventListener("input", function(){
            //         let newLetterSpacing = this.value + 'em';
            //         sampleText.style.letterSpacing = newLetterSpacing;        
            //     });
            // }
            // if(rangeLineHeight){    
            //     rangeLineHeight.addEventListener("input", function(){
            //         let newLineHeight = this.value;
            //         console.log(newLineHeight);
            //         sampleText.style.lineHeight = newLineHeight;        
            //     }); 
            // }        

            // number inputs //
            const fontVariant = typeTester[i].querySelector('.font-variant');
            const numberLetterSpacing = typeTester[i].querySelector('.letter-spacing[type="number"]');
            const numberLineHeight = typeTester[i].querySelector('.line-height[type="number"]');
            let letterSpacingOg, lineHeightOg;

            if (fontVariant) {
                fontVariant.addEventListener("change", function () {
                    sampleText.style.fontFamily = '"'+this.value+'"';
                });
            }

            if (typeSizeInput) {
                typeSizeInput.addEventListener("input", function () {
                    let newFontSize = this.value / window.innerWidth * 100 + 'vw';
                    sampleText.style.fontSize = newFontSize;
                });
            }
            if (numberLetterSpacing) {
                letterSpacingOg = numberLetterSpacing.value;
                numberLetterSpacing.addEventListener("input", function () {
                    let newLetterSpacing = this.value + 'em';
                    sampleText.style.letterSpacing = newLetterSpacing;
                });
            }
            if (numberLineHeight) {
                lineHeightOg = numberLineHeight.value;
                numberLineHeight.addEventListener("input", function () {
                    let newLineHeight = this.value;
                    sampleText.style.lineHeight = newLineHeight;
                    const ogLineHeight = typeTester[i].querySelector('.styles-div').style.lineHeight;
                    if (newLineHeight < ogLineHeight) {
                        sampleText.style.marginTop = ogLineHeight - newLineHeight + 'em';
                    } else {
                        sampleText.style.marginTop = 0;
                    }
                });
            }

            typeTester[i].querySelector(".reset").addEventListener("click", function () {
                sampleText.removeAttribute('style');
                sampleText.innerText = originalWords;
                let ogStyles = window.getComputedStyle(sampleText.parentElement, null);
                // reset font variant //
                fontVariant.value = ogStyles.fontFamily.replace(/^"(.*)"$/, '$1');
                const reset = new Event('click');
                fontVariant.parentElement.querySelector('.select-items').childNodes[fontVariant.selectedIndex].dispatchEvent(reset);
                // reset other inputs //
                typeSizeInput.value = parseInt(ogStyles.fontSize);
                numberLetterSpacing.value = letterSpacingOg;
                numberLineHeight.value = lineHeightOg;
            });

            typeTester[i].querySelector(".align-left").addEventListener("click", function () {
                sampleText.style.textAlign = 'left';
            });

            typeTester[i].querySelector(".align-center").addEventListener("click", function () {
                sampleText.style.textAlign = 'center';
            });

            typeTester[i].querySelector(".align-right").addEventListener("click", function () {
                sampleText.style.textAlign = 'right';
            });

            const inputElement = document.querySelectorAll('.type-controls input[type="number"]');
            if (inputElement) {
                for (let i = 0; i < inputElement.length; i++) {
                    //inputElement[i].addEventListener('input', updateSuffix(this));
                    inputElement[i].addEventListener('input', function () {
                        updateSuffix(inputElement[i]);
                    });
                    updateSuffix(inputElement[i]);
                }
            }


        }
        const twoColsSamples = document.querySelectorAll('.two-col-type-tester .sample-text');
        if (twoColsSamples) {
            twoColsSamples.forEach(twoColsSample => {
                twoColsSample.addEventListener('focus', function () {
                    if (this.classList.contains('right')) {
                        this.closest('.two-col-type-tester').classList.add('right-active');
                    } else {
                        this.closest('.two-col-type-tester').classList.remove('right-active');
                    }
                });
            })
        }
    }

    // custom select https://www.w3schools.com/howto/howto_custom_select.asp //
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 0; j < ll; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function (e) {
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();

                s.dispatchEvent(new Event("change"));
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }
    document.addEventListener("click", closeAllSelect);
    // end custom select //

    const glyphBtn = document.querySelectorAll('.glyph');
    const glyphDetail = document.querySelector('.glyph-detail div');
    if (glyphBtn) {
        for (let i = 0; i < glyphBtn.length; i++) {
            glyphBtn[i].addEventListener('click', function () {
                if (!this.classList.contains('active')) {
                    let active = document.querySelector('.glyph.active');
                    if (active) {
                        active.classList.remove('active');
                    }
                    this.classList.add('active');
                    glyphDetail.innerHTML = this.querySelector('div').innerHTML;
                }
            });
        }
    }


    glyphsMobile();
    window.addEventListener('resize', function () {
        glyphsMobile();
    });


    const popupImg = document.querySelectorAll('.popup');
    if (popupImg) {
        for (let i = 0; i < popupImg.length; i++) {
            popupImg[i].addEventListener('click', function () {

                let src = this.src;

                const popup = document.createElement('div');
                popup.className = "popup-wrap";

                const popupInner = document.createElement('div');
                popupInner.className = "container";

                // const popupOuterWrap = document.createElement('div');
                // popupOuterWrap.className = "colspan-12";

                const popupInnerWrap = document.createElement('div');
                popupInnerWrap.className = "colspan-10";

                const popupImg = document.createElement('img');
                popupImg.src = src;

                const popupClose = document.createElement('button');
                popupClose.innerHTML = '<svg viewBox="0 0 24 24"><path d="M23.6,0.4c-0.5-0.5-1.2-0.5-1.7,0l-10,10L2,0.4c-0.5-0.5-1.2-0.5-1.7,0c-0.5,0.5-0.5,1.2,0,1.7l10,10l-10,10 c-0.5,0.5-0.5,1.2,0,1.7C0.6,23.9,0.9,24,1.2,24s0.6-0.1,0.8-0.4l10-10l10,10c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.1,0.8-0.4 c0.5-0.5,0.5-1.2,0-1.7l-10-10l10-10C24.1,1.6,24.1,0.8,23.6,0.4z"/></svg>';
                popupClose.className = 'close-popup';

                popupInner.appendChild(popupClose);
                popupInnerWrap.appendChild(popupImg);
                popupInner.appendChild(popupInnerWrap);
                popup.appendChild(popupInner);
                document.body.appendChild(popup);

                popupClose.addEventListener('click', function () {
                    popup.remove();
                });

            });
        }
    }



    //let fontMetrics = [];
    //function measureFont() {
    //    // Create a blank canvas (by not filling a background color).
    //    var canvas = document.getElementById('canvas');
    //    if (canvas) {
    //        var fontFamily = canvas.dataset.fontfamily;
    //        var ctx = canvas.getContext('2d');

    //        // Fill it with some coloured text.. (black is default)
    //        ctx.font = "100px " + fontFamily;
    //        ctx.textBaseline = "top";
    //        ctx.fillText("Mpl", 0, 0);

    //        // const textSizer = document.createElement('div');
    //        // textSizer.innerText = "Mpl";
    //        // textSizer.style.fontFamily = fontFamily;
    //        // textSizer.style.fontSize = '100px';
    //        // textSizer.style.position = 'fixed';
    //        // textSizer.style.lineHeight = 1;
    //        // document.body.appendChild(textSizer);
    //        // let ogMetrics = [textSizer.getBoundingClientRect().width,textSizer.getBoundingClientRect().height];
    //        const measureRect = document.querySelector('.measure').getBoundingClientRect()
    //        const ogHeight = measureRect.height
    //        const baseline = document.querySelector('.measure .baseline').getBoundingClientRect().bottom - measureRect.top
    //        //document.body.removeChild(textSizer);



    //        // Remove the surrounding transparent pixels
    //        // result is an actual canvas element
    //        var result = trim(canvas);

    //        // you could query it's width, draw it, etc..
    //        //document.body.appendChild(result);

    //        const marTop = (1 - (result.height / ogHeight)) / 2;
    //        //const marTop = ((result.height - 100)/2)/100;
    //        const lineHeight = result.height / ogHeight + marTop;
    //        //console.log(marTop,lineHeight,result.height,result.width);
    //        //fontMetrics = [result.width/ogMetrics[0],result.height/ogMetrics[1]];



    //        var sheet = window.document.styleSheets[0];

    //        sheet.insertRule('.glyphs .table .glyph div,.glyph-detail div,.glyph-slider .swiper-slide span { transform: translateY(' + marTop + 'em); }', sheet.cssRules.length);

    //        const typeTesters = document.querySelectorAll('.type-tester');
    //        if (typeTesters) {
    //            typeTesters.forEach(typeTester => {
    //                const lineHeightField = typeTester.querySelector('.line-height[type="number"]');
    //                typeTester.querySelector('.styles-div').style.lineHeight = lineHeight;
    //                typeTester.querySelector('.styles-div').style.transform = 'translateY(' + marTop * 0.5 + 'em)';
    //                //typeTester.querySelector('.styles-div').style.textIndent = '-' + ((ogMetrics[0] - result.width)/100) + 'em';
    //                lineHeightField.value = lineHeight;
    //                var event = document.createEvent('Event');
    //                event.initEvent('input', true, true);
    //                lineHeightField.dispatchEvent(event);
    //            });
    //        }
    //    }
    //}
    //measureFont();  


    // Trim Canvas Pixels Method
    // https://gist.github.com/remy/784508
    function trim(c) {

        var ctx = c.getContext('2d'),

            // create a temporary canvas in which we will draw back the trimmed text
            copy = document.createElement('canvas').getContext('2d'),

            // Use the Canvas Image Data API, in order to get all the
            // underlying pixels data of that canvas. This will basically
            // return an array (Uint8ClampedArray) containing the data in the
            // RGBA order. Every 4 items represent one pixel.
            pixels = ctx.getImageData(0, 0, c.width, c.height),

            // total pixels
            l = pixels.data.length,

            // main loop counter and pixels coordinates
            i, x, y,

            // an object that will store the area that isn't transparent
            bound = { top: null, left: null, right: null, bottom: null };

        // for every pixel in there
        for (i = 0; i < l; i += 4) {

            // if the alpha value isn't ZERO (transparent pixel)
            if (pixels.data[i + 3] !== 0) {

                // find it's coordinates
                x = (i / 4) % c.width;
                y = ~~((i / 4) / c.width);

                // store/update those coordinates
                // inside our bounding box Object

                if (bound.top === null) {
                    bound.top = y;
                }

                if (bound.left === null) {
                    bound.left = x;
                } else if (x < bound.left) {
                    bound.left = x;
                }

                if (bound.right === null) {
                    bound.right = x;
                } else if (bound.right < x) {
                    bound.right = x;
                }

                if (bound.bottom === null) {
                    bound.bottom = y;
                } else if (bound.bottom < y) {
                    bound.bottom = y;
                }
            }
        }

        // actual height and width of the text
        // (the zone that is actually filled with pixels)
        var trimHeight = bound.bottom - bound.top,
            trimWidth = bound.right - bound.left,

            // get the zone (trimWidth x trimHeight) as an ImageData
            // (Uint8ClampedArray of pixels) from our canvas
            trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

        // Draw back the ImageData into the canvas
        copy.canvas.width = trimWidth;
        copy.canvas.height = trimHeight;
        copy.putImageData(trimmed, 0, 0);

        // return the canvas element
        return copy.canvas;
    }




    const textAdjust = document.querySelector('div[data-name="font_height_adjustment"] input');

    if (textAdjust) {
        textAdjust.addEventListener("input", () => {
            //console.log(textAdjust.value)
            //const sheet = window.document.styleSheets[0];
            const sheet = document.querySelector('main style').sheet;
            sheet.insertRule('.glyphs .table .glyph div,.glyph-detail div,.glyph-slider .swiper-slide span { transform: translateY(' + textAdjust.value + 'em); }', sheet.cssRules.length);
        })
    }

    const prevNextBtns = document.querySelectorAll('.prev-next-font a');
    if(prevNextBtns){
        prevNextBtns.forEach((prevNextBtn)=>{
            prevNextBtn.addEventListener('click',()=>{
                scrollValues[prevNextBtn.href] = 0;
            });
        });    
    }

}

//let scrollValues = {};

init();
swup.on('contentReplaced', init);


// document.addEventListener("swup:clickLink", (e) => {
//     scrollValues[window.location.href] = window.scrollY;
// });

// document.addEventListener("swup:contentReplaced", () => {
//     if (window.location.hash && document.querySelector(window.location.hash)) {
//         document.querySelector(window.location.hash).scrollIntoView();
//     } else {
//         const scrollPos = scrollValues[window.location.href] ? scrollValues[window.location.href] : 0;
//         window.scrollTo(0, scrollPos);
//     }
// });

let indexPos = 0;

document.addEventListener("swup:clickLink", (e) => {
    let pathArr = window.location.pathname.split('/').filter(Boolean);
    if(pathArr[pathArr.length - 1] === 'fonts'){
        indexPos = window.scrollY;
    }
});

document.addEventListener("swup:contentReplaced", () => {
    let pathArr = window.location.pathname.split('/').filter(Boolean);
    if(pathArr[pathArr.length - 1] === 'fonts'){
        window.scrollTo(0,indexPos);
    }else{
        window.scrollTo(0,0);
    }
});